// Dependencies
import styled, { keyframes } from "styled-components";

// Utils
import { theme } from "config/theme";

export const Container = styled.div`
    position: fixed;
    pointer-events: auto;
    visibility: visible;
    opacity: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
`;

export const Overlay = styled.div`
    display: flex;
    justify-content: center;
    background-color: rgba(35, 35, 38, 0.5);
    align-items: flex-end;

    width: 100%;
    height: 100%;
    padding: auto 0;
`;

export const slideUp = keyframes`
    from {
        transform: translateY(100%);
    }

    to {
        transform: translateY(0%);
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    position: relative;
    justify-content: center;
    flex: 0 0 100%;
    animation: slideUp ease-in 0.2s backwards;
    animation-delay: 0.1s;
`;

export const BottomSheetContainer = styled.div`
    padding: 1rem;
    background-color: ${theme.colors.white};
    border-radius: 1rem 1rem 0 0;
    width: 100%;
    max-height: 65vh;
    transition: max-height 0.3s ease-in-out;

    .webp-search-input {
        margin-bottom: 1rem;
    }
`;

export const PlaceholderLabel = styled.p`
    font-family: "Nunito", sans-serif;
    font-style: normal;
    text-align: center;
    font-size: 1rem;
    font-weight: 600;

    letter-spacing: 0;
    line-height: 1.375;
    padding-top: 2rem;
`;

export const BottomSheetContent = styled.div`
    max-height: 40vh;

    overflow-y: scroll;
    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.base[200]} ${theme.colors.base[100]};

    &::-webkit-scrollbar {
        width: 4px;
    }

    &::-webkit-scrollbar-track {
        background: ${theme.colors.base[100]};
    }

    &::-webkit-scrollbar-thumb {
        background-color: ${theme.colors.base[200]};
        border-radius: 20px;
    }
`;
